import types from '../types/deposit'

export default class deposit {

  static setStep(step) {
    return {
      type: types.SET_STEP,
      payload: {
        step,
      },
    }
  }

  static nextStep() {
    return {
      type: types.NEXT_STEP,
    }
  }

  static nextStepFromStart() {
    return function(dispatch, getState) {

      let nextStep = 2
      let addressTab = 0
      if (getState().domain.user.missingProfileInformation.indexOf('address') !== -1) {
        nextStep = 3
        addressTab = 1
      }

      dispatch({
        type: types.NEXT_STEP_FROM_START,
        payload: {
          step: nextStep,
          addressTab: addressTab,
        }
      })
    }
  }

  static nextStepFromAddress() {
    return {
      type: types.NEXT_STEP_FROM_ADDRESS,
    }
  }

  static nextStepFromCard() {
    return {
      type: types.NEXT_STEP_FROM_CARD,
    }
  }

  static nextStepFromReview() {
    return {
      type: types.NEXT_STEP_FROM_REVIEW,
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/deposit/actions/deposit.js